// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"effe35e2ace4ee75b78f","655":"509a35b6215636b64e4c"}[chunkId] + ".js";
};